import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from '@apollo/client';
import { createAuthLink, AUTH_TYPE, AuthOptions } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import {
  AppSyncConfig,
  ProductsAppSyncConfig,
  FavGroupsAppSyncConfig,
  CampaignsAppSyncConfig,
} from './config';
import PageHeaderUtils from 'utils/page-header';

export function createApolloClient(url: string, apiKey: string, cache: any): ApolloClient<any> {
  const auth: AuthOptions = {
    type: AUTH_TYPE.API_KEY,
    apiKey,
  };

  const region = 'us-west-2';
  const httpLink = createHttpLink({ uri: url });

  const link = ApolloLink.from([
    createAuthLink({ url, region, auth }),
    createSubscriptionHandshakeLink(url, httpLink),
  ]);

  return new ApolloClient({
    link: link,
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
      query: {
        fetchPolicy: 'network-only',
      },
    },
  });
}

export const client = createApolloClient(
  AppSyncConfig.graphqlEndpoint,
  AppSyncConfig.apiKey,
  new InMemoryCache({ addTypename: false })
);

export const productsClient = createApolloClient(
  ProductsAppSyncConfig.graphqlEndpoint,
  ProductsAppSyncConfig.apiKey,
  new InMemoryCache({
    addTypename: false,
    typePolicies: {
      HeliosProduct: {
        keyFields: (object) => object.upc as string,
      },
      Store: {
        keyFields: (object) =>
          PageHeaderUtils.createStoreId(object.spinsTag, object.nielsenTag) as string,
      },
    },
  })
);

export const favGroupsClient = createApolloClient(
  FavGroupsAppSyncConfig.graphqlEndpoint,
  FavGroupsAppSyncConfig.apiKey,
  new InMemoryCache({ addTypename: false })
);

export const campaignsClient = createApolloClient(
  CampaignsAppSyncConfig.graphqlEndpoint,
  CampaignsAppSyncConfig.apiKey,
  new InMemoryCache({ addTypename: false })
);
